import { useEffect } from 'react'

export const useScrollLock = () => {
    useEffect(() => {
        const original = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => { document.body.style.overflow = original }
    }, [])
}
